import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import http from "@/lib/api";

export default function Reviews() {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    http.get("/v1/reviews").then((r) => setReviews(r.data)).catch(() => setReviews([]));
  }, []);

  if (!reviews.length) return null;

  return (
    <section className="py-16 md:py-24 bg-[#FFF8F0]" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-[#3D2314] mb-4 font-display">Hva kundene sier</h2>
          <p className="text-[#1A1A1A]/70 max-w-2xl mx-auto">
            Les hva våre fornøyde kunder sier om tjenestene våre.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((rev) => (
            <div key={rev.id || rev.name} className="bg-white rounded-xl p-6 shadow-sm border border-[#D4A574]/20">
              <div className="flex gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className={`h-4 w-4 ${i < rev.rating ? "text-[#D4A574] fill-[#D4A574]" : "text-gray-200"}`} />
                ))}
              </div>
              <p className="text-sm text-[#1A1A1A]/80 mb-4 italic">"{rev.comment}"</p>
              <div className="flex items-center justify-between">
                <span className="font-semibold text-[#3D2314] text-sm">{rev.name}</span>
                <span className="text-xs text-[#D4A574] font-medium">{rev.service_type}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
